import type { CheckRunContext } from '../types/checks.js';
import type { AuthenticityAssessment, AuthenticitySignalId } from './index.js';
import { assessAuthenticity } from './aiManipulation.js';

/**
 * The retouching ensemble.
 *
 * Retouching and appearance change are judged from the skin texture (D), the
 * local skin contrast with preserved edges (E) and two supporting signals: the
 * compression history (A) and clone/copy-paste (H). The ensemble is never a
 * claim about a person and never a legal statement — at most it is a `warning`.
 */

export const RETOUCHING_SIGNAL_IDS: readonly AuthenticitySignalId[] = [
  'face_texture',
  'skin_smoothing',
  'compression_history',
  'clone',
];

export const RETOUCHING_WEIGHTS: Partial<Record<AuthenticitySignalId, number>> = {
  face_texture: 0.3,
  skin_smoothing: 0.3,
  compression_history: 0.2,
  clone: 0.2,
};

export const assessRetouching = (ctx: CheckRunContext): AuthenticityAssessment =>
  assessAuthenticity(ctx, {
    signalIds: RETOUCHING_SIGNAL_IDS,
    weights: RETOUCHING_WEIGHTS,
  });
